@if (shareUi.shareTarget()) {
  <div class="share-anchor me-2" (pointerdown)="onAnchorPointerDown($event)">
    <button
      type="button"
      class="d-flex align-items-center justify-content-center btn btn-drive-share py-2 px-1"
      [class.active]="shareUi.shareOpen()"
      [title]="toggleTitle"
      [attr.aria-label]="toggleTitle"
      [attr.aria-haspopup]="'dialog'"
      [attr.aria-expanded]="shareUi.shareOpen()"
      (click)="onToggle($event)">
      <span class="icon-wrapper">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="drive-share-icon">
          <circle cx="18" cy="5" r="2.6" stroke="currentColor" stroke-width="1.8" />
          <circle cx="6" cy="12" r="2.6" stroke="currentColor" stroke-width="1.8" />
          <circle cx="18" cy="19" r="2.6" stroke="currentColor" stroke-width="1.8" />
          <path d="m8.3 13.4 7.4 4.2M15.7 6.4 8.3 10.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      </span>
    </button>
    @if (shareUi.shareOpen() && asset(); as shareAsset) {
      <mtm-share-dialog
        [asset]="shareAsset"
        [conversationFeeds]="shareUi.conversationFeeds()"
        [serverError]="serverError()"
        (confirmed)="onConfirmed($event)"
        (cancelled)="onCancelled()" />
    }
  </div>
}
